import React from 'react'
import { Grid, Avatar, Typography, Divider } from '@mui/material';
import EditorViewComponent from '../../common/editor/EditorViewComponent';

const SingleHistory = (props) => {
    return (
        <React.Fragment>

            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
            >
                <Grid
                    item
                    xs={2}
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item>
                        {props.history.profileImg ? (
                            <Avatar alt={props.history.crtNm} src={props.history.profileImg} />
                        ) : (
                            <Avatar>{props.history.crtNm.substring(0, 1)}</Avatar>
                        )}
                    </Grid>
                    <Grid item>
                        <Typography variant="body2" component="div">{props.history.crtNm}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2" component="div">{props.history.crtDt}</Typography>
                    </Grid>
                </Grid>

                <Grid
                    item
                    container
                    xs={10}
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                >
                    <Grid
                        item
                        sx={{ width: '100%', minHeight: '50px', whiteSpace: 'pre-line' }}
                    >
                        <EditorViewComponent content={props.history.brdTxt} />
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>

    )
}

export default SingleHistory